import * as CrowdManage from '../services/crowdManage';

export default {
  namespace: 'crowdManage',

  state: {
    crowdPageList: null,
    configList: [],
  },

  effects: {
    //人员管理列表
    *getCrowdList({ payload: { values } }, { call, put }) {
      const response = yield call(CrowdManage.getCrowdList, values);
      yield put({
        type: 'save',
        payload: {
          crowdPageList: response?.data,
        },
      });
    },
    //人群下载
    *groupDownloadMember({ payload: { values }, callback }, { call }) {
      const response = yield call(CrowdManage.groupDownloadMember, values);
      callback(response);
    },
    //人群导出字段配置
    *queryGroupExportConfigList(_, { call, put }) {
      const response = yield call(CrowdManage.queryGroupExportConfigList);
      yield put({
        type: 'save',
        payload: {
          configList: response.data,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
